import React, { useEffect, useState } from "react";
import { ContentWrapper } from "~/Components";
import { magpBEApi } from "~/Services";
import { ChartCard } from "./ChartCard";
import { StatCard } from "./StatCard";

export interface LoginData {
  date: string;
  loginType: string;
  emailId: string;
  count: number;
}

export const Dashboard: React.FC = () => {
  const [statsData, setStatsData] = useState<any>([]);
  const [startDateType, setStartDateType] = useState<string>("");
  const [endDateType, setEndDateType] = useState<string>("");
  const [dataType, setDataType] = useState<string>("monthly");
  const [data, setData] = useState<any>([]);

  console.log("dashboard", startDateType, endDateType, dataType);

  useEffect(() => {
    getStatsCardRecord();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      getStatsCardRecord();
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);

  // useEffect(() => {
  //   setStartDateType('');
  //   setEndDateType('');
  // }, [dataType]);

  useEffect(() => {
    getChartCardRecords(dataType, startDateType, endDateType);
  }, [startDateType, endDateType, dataType]);

  const getStatsCardRecord = () => {
    let url = `/api/visitors/card-view`;
    magpBEApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data.data;
          console.log("envelopes", envelopes);
          setStatsData(envelopes);
        }
      })
      .catch((err) => {
        setStatsData([]);
      });
  };

  const getChartCardRecords = (type: string, startDate: string, endDate: string) => {
    let url = `/api/visitors/graph-view?type=${type ?? "monthly"}${startDate ? `&startDate=${startDate}` : ""}${
      endDate ? `&endDate=${endDate}` : ""
    }`;
    magpBEApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data.data;
          setData(envelopes);
        }
      })
      .catch((err) => {
        setData([]);
      });
  };

  return (
    <ContentWrapper title="Dashboard">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <StatCard data={statsData} />
      </div>
      <div className="mt-5">
        <div style={{ width: "100%", paddingBottom: "15px" }}>
          <div style={{ minWidth: "100%" }}>
            <ChartCard
              data={data}
              startDateType={startDateType}
              endDateType={endDateType}
              setStartDateType={setStartDateType}
              setEndDateType={setEndDateType}
              setDataType={setDataType}
              dataType={dataType}
              title="Chart"
              exportData={`/api/visitors/details?type=${dataType}${startDateType && `&startDate=${startDateType}`}${endDateType && `&endDate=${endDateType}`}`}
            />
          </div>
        </div>
      </div>
    </ContentWrapper>
  );
};
